import { Subject } from 'rxjs';

export class TabToTabChannelModel {
    readonly broadcastChannel: BroadcastChannel;
    readonly messageSubject$ = new Subject<any>();
    readonly guid: string;
    readonly channelName: string;

    constructor(channelName: string, guid: string) {
        this.broadcastChannel = new BroadcastChannel(channelName);
        this.guid = guid;
        this.channelName = channelName;
        this.broadcastChannel.onmessage = (event) => this.messageSubject$.next(event.data);
        this.broadcastChannel.onmessageerror = (event) => this.messageSubject$.error(event.data);
    }

    get key(): string {
        return `${this.channelName}${!!this.guid ? '_' + this.guid : ''}`;
    }
}
